export default __webpack_public_path__ + "static/top-bg-sm-4b66a1714dea6fbed7de7a9a8933942b.png";